import {
  TERMINAL_FETCH_REQUEST,
  TERMINAL_FETCH_REQUEST_SUCCESS,
  TERMINAL_FETCH_REQUEST_FAILURE,
  TERMINAL_ADD_REQUEST,
  TERMINAL_ADD_REQUEST_SUCCESS,
  TERMINAL_ADD_REQUEST_FAILURE,
  TERMINAL_UPDATE_REQUEST,
  TERMINAL_UPDATE_REQUEST_SUCCESS,
  TERMINAL_UPDATE_REQUEST_FAILURE,
  TERMINAL_COUNT_FETCH_REQUEST,
  TERMINAL_COUNT_FETCH_REQUEST_SUCCESS,
  TERMINAL_COUNT_FETCH_REQUEST_FAILURE,
  TERMINAL_CLEAN_REQUEST,
  TERMINAL_ERROR_CLEAN_REQUEST,
  TERMINAL_DISPATCH_FETCH_REQUEST,
  TERMINAL_DISPATCH_FETCH_REQUEST_SUCCESS,
  TERMINAL_DISPATCH_FETCH_REQUEST_FAILURE,
  TERMINAL_DISPATCH_ADD_REQUEST,
  TERMINAL_DISPATCH_ADD_REQUEST_SUCCESS,
  TERMINAL_DISPATCH_ADD_REQUEST_FAILURE,
  TERMINAL_DISPATCH_UPDATE_REQUEST,
  TERMINAL_DISPATCH_UPDATE_REQUEST_SUCCESS,
  TERMINAL_DISPATCH_UPDATE_REQUEST_FAILURE,
  TERMINAL_STATUS_FETCH_REQUEST_SUCCESS,
  TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST,
  TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_SUCCESS,
  TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_FAILURE,
  TERMINAL_CONFIGURE_SWITCH_KCV_CLEAN_REQUEST,
} from '../constants/actionTypes';

const TERMINAL_KCV_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const terminalsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_FETCH_REQUEST:
    case TERMINAL_ADD_REQUEST:
    case TERMINAL_UPDATE_REQUEST:
    case TERMINAL_COUNT_FETCH_REQUEST:
    case TERMINAL_DISPATCH_FETCH_REQUEST:
    case TERMINAL_DISPATCH_ADD_REQUEST:
    case TERMINAL_DISPATCH_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_FETCH_REQUEST_SUCCESS:
    case TERMINAL_DISPATCH_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
        },
      });

    case TERMINAL_STATUS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data.data,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,

          showSizeChanger: true,
        },
      });

    case TERMINAL_DISPATCH_ADD_REQUEST_SUCCESS:
    case TERMINAL_DISPATCH_UPDATE_REQUEST_SUCCESS:
    case TERMINAL_ADD_REQUEST_SUCCESS:
    case TERMINAL_UPDATE_REQUEST_SUCCESS:
    case TERMINAL_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_FETCH_REQUEST_FAILURE:
    case TERMINAL_ADD_REQUEST_FAILURE:
    case TERMINAL_UPDATE_REQUEST_FAILURE:
    case TERMINAL_COUNT_FETCH_REQUEST_FAILURE:
    case TERMINAL_DISPATCH_FETCH_REQUEST_FAILURE:
    case TERMINAL_DISPATCH_ADD_REQUEST_FAILURE:
    case TERMINAL_DISPATCH_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });
    case TERMINAL_ERROR_CLEAN_REQUEST:
      return Object.assign({}, state, {
        errors: {},
      });

    default:
      return state;
  }
};

// export default terminalsReducer;

export const terminalKcvReducer = (state, action) => {
  state = state || TERMINAL_KCV_INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_CONFIGURE_SWITCH_KCV_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_CONFIGURE_SWITCH_KCV_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
